// extracted by mini-css-extract-plugin
module.exports = {"AssetFlat":"AssetFence_AssetFlat__3grbA"};